import React, { FC } from 'react';

const AdminAuthPage: FC<unknown> = () => {
  return <></>;
};
export default AdminAuthPage;
